<template>
  <div v-if="show" class="popup-overlay" @click="closePopup">
    <div class="popup-content" @click.stop>
      <div class="popup-icon" :class="type">
        <span v-if="type === 'success'">✓</span>
        <span v-if="type === 'error'">✕</span>
        <span v-if="type === 'warning'">⚠</span>
      </div>
      <h3>{{ title }}</h3>
      <p>{{ message }}</p>
      <div v-if="type === 'warning'" class="popup-buttons">
        <button @click="closePopup" class="popup-btn cancel-btn">Cancel</button>
        <button @click="confirmAction" class="popup-btn confirm-btn">Delete</button>
      </div>
      <button v-else @click="closePopup" class="popup-btn">OK</button>
    </div>
  </div>
</template>

<script setup>
import { COLORS, FONTS } from '@/styles/brand'

defineProps({
  show: Boolean,
  type: String, // 'success' or 'error'
  title: String,
  message: String
})

const emit = defineEmits(['close', 'confirm'])

const closePopup = () => {
  emit('close')
}

const confirmAction = () => {
  emit('confirm')
}
</script>

<style scoped>
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
}

.popup-content {
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.1) 100%);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  padding: 40px;
  text-align: center;
  max-width: 400px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
  animation: popupIn 0.3s ease-out;
}

.popup-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  font-size: 24px;
  font-weight: bold;
}

.popup-icon.success {
  background: v-bind('COLORS.SECONDARY.GREEN');
  color: white;
}

.popup-icon.error {
  background: v-bind('COLORS.PRIMARY.RED');
  color: white;
}

.popup-icon.warning {
  background: #FFA500;
  color: white;
}

.popup-buttons {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.cancel-btn {
  background: rgba(255, 255, 255, 0.2) !important;
}

.confirm-btn {
  background: #000000 !important;
}

.popup-content h3 {
  color: v-bind('COLORS.PRIMARY.WHITE');
  font-family: v-bind('FONTS.PRIMARY');
  font-size: 1.5rem;
  margin: 0 0 16px 0;
}

.popup-content p {
  color: rgba(255, 255, 255, 0.8);
  margin: 0 0 24px 0;
  font-size: 1rem;
}

.popup-btn {
  padding: 12px 32px;
  color: white;
  border: none;
  border-radius: 50px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.popup-btn:not(.cancel-btn):not(.confirm-btn) {
  background: v-bind('COLORS.PRIMARY.RED');
}

.popup-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
}

@keyframes popupIn {
  from {
    opacity: 0;
    transform: scale(0.8) translateY(20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
</style>